var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaywatchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 28,
    viewBox: "0 0 22 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.14068 7.64624H0V9.58027V20.515V27.7892H2.14068V20.6638H13.9118V9.42954H2.14068V7.64624ZM11.7711 11.7962V18.2971H2.13891V11.7962H11.7711Z",
    fill: "#1CE6B0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9118 0.568115H11.7712V5.95326H13.9118V0.568115Z",
    fill: "#1CE6B0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 9.42212H17.129V11.7888H22V9.42212Z",
    fill: "#1CE6B0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5753 2.67898L15.131 6.48682L16.6447 8.16027L20.0889 4.35243L18.5753 2.67898Z",
    fill: "#1CE6B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaywatchIcon);
export default __webpack_public_path__ + "static/media/paywatchIcon.5cd0cda3d4f964deb1e76ca199fed8f8.svg";
export { ForwardRef as ReactComponent };